export default "__VITE_ASSET__7MZlbNKC__"